import React from "react";
import { Form, Select, Input, Checkbox } from "antd";

const cityOption = [
  {value: 'Karachi', label: 'Karachi'},
  {value: 'Lahore', label: 'Lahore'},
  {value: 'Rawalpindi', label: 'Rawalpindi'},
]

const Edit = () => {
  return (<>
    <Form.Item
      name={["fullName"]}
      label={"Name"}
      rules={[{required: true, message: "Your Full Name is Required"}]}
    >
      <Input placeholder="Full Name"/>
    </Form.Item>
    <Form.Item
      name={"cnic"}
      label={"CNIC Number"}
      rules={[
        {required: true, message: "Your CNIC number is required"},
        {pattern: new RegExp(/^[0-9]{13}$/), message: "CNIC format. 13 numbers without -"},
      ]}
    >
      <Input placeholder="CNIC" style={{width:'100%'}} />
    </Form.Item>
    <Form.Item
      name={"city"}
      label={"City"}
      rules={[{required: true, message: "City is Required"}]}
    >
      <Select
        showSearch
        allowClear
        filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        options={cityOption}
        style={{minWidth: "200px"}}
      />
    </Form.Item>
    <Form.Item
      name={"phoneNumber"}
      label={"Phone Number"}
      rules={[
        {required: true, message: "Your Phone Number is Required"},
        {pattern: /^(\+92)[0-9]{10}$/, message: "+923000000000 Phone number format. 10 numbers add after +92 "},
      ]}
    >
      <Input placeholder="Phone Number eg.+92**" />
    </Form.Item>
    <Form.Item
      name={"email"}
      label={"Email"}
      rules={[{type: "email", required: true, message: "Email is Required"}]}
    >
      <Input placeholder="Email" />
    </Form.Item>
    <Form.Item
      name="role"
      label="Roles"
      rules={[{ required: true, message: "At least one role is required" }]}
    >
      <Checkbox.Group>
        <Checkbox value="picker">Picker</Checkbox>
        <Checkbox value="packer">Packer</Checkbox>
      </Checkbox.Group>
    </Form.Item>
    {/* <Form.Item
      name={"password"}
      label={"Password"}
      rules={[
        {required: true, message: "Your PassCode number is required", pattern: new RegExp(/^[0-9]+$/)},
        {type: "number", min: 0, max: 9999, message: "Please enter your complete PassCode number"}
      ]}
    >
      <InputNumber placeholder="PassCode" style={{width:'100%'}} />
    </Form.Item> */}

    {/* <Form.Item
      name="profileImage"
      valuePropName="fileList"
      getValueFromEvent={normFile}
    >
      <Upload
        listType="picture-card"
        className="avatar-uploader"
        showUploadList={true}
        maxCount={1}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="avatar"
            style={{ width: "100%" }}
          />
        ) : (
          uploadProfileImageButton
        )}
      </Upload>
    </Form.Item> */}
  </>);
};
export default Edit;
